(function(){
  "use strict";
  document.querySelectorAll('.rin-hero[data-rin-sid]').forEach(function(root){
    var sid = root.getAttribute('data-rin-sid');
    var input = root.querySelector('input[name="id"]');
    var atcPrice = root.querySelector('[data-rin-atc-price]');
    var atcBtn = root.querySelector('.rin-hero__atc');
    var sticky = document.querySelector('.rin-sticky[data-rin-sid="' + sid + '"]');
    var stickyLine = sticky ? sticky.querySelector('[data-rin-sticky-line]') : null;
    var stickyPrice = sticky ? sticky.querySelector('[data-rin-sticky-price]') : null;
    var stickyBtn = sticky ? sticky.querySelector('.rin-sticky__btn') : null;
    var cards = root.querySelectorAll('.rin-bcard');
    var slides = root.querySelectorAll('.rin-hero__slide');
    var dots = root.querySelectorAll('.rin-hero__thumb');
    var gift = root.querySelector('.rin-hero__gift');
    var firstMid = slides.length ? slides[0].getAttribute('data-media-id') : null;
    var variantMedia = (window.rinVariantMedia && window.rinVariantMedia[sid]) || {};

    function showMedia(mid){
      slides.forEach(function(s){ s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(mid)); });
      dots.forEach(function(d){ d.classList.toggle('is-on', d.getAttribute('data-media-id') === String(mid)); });
      // Le badge cadeau ne s'affiche que sur la 1re image (les autres ont leur propre titre)
      if(gift && firstMid) gift.style.display = (String(mid) === firstMid) ? '' : 'none';
    }
    dots.forEach(function(d){ d.addEventListener('click', function(){ showMedia(d.getAttribute('data-media-id')); }); });

    // Flèches de galerie : 364 clics/15 j sur l'image avec 19,3 s d'hésitation médiane —
    // les visiteurs cherchaient à naviguer sans repère visible.
    var order = Array.prototype.map.call(slides, function(s){ return s.getAttribute('data-media-id'); });
    function currentIdx(){
      for (var i = 0; i < slides.length; i++) { if (slides[i].classList.contains('is-active')) return i; }
      return 0;
    }
    function step(dir){ if (order.length > 1) showMedia(order[(currentIdx() + dir + order.length) % order.length]); }
    var prev = root.querySelector('[data-rin-prev]'), next = root.querySelector('[data-rin-next]');
    if (prev) prev.addEventListener('click', function(){ step(-1); });
    if (next) next.addEventListener('click', function(){ step(1); });

    // Swipe tactile (+ glisser souris) sur l'image principale
    var main = root.querySelector('.rin-hero__main');
    if(main && slides.length > 1){
      var order = Array.prototype.map.call(slides, function(s){ return s.getAttribute('data-media-id'); });
      main.style.touchAction = 'pan-y';
      function currentIndex(){
        for(var i=0;i<slides.length;i++){ if(slides[i].classList.contains('is-active')) return i; }
        return 0;
      }
      function go(dir){ showMedia(order[(currentIndex() + dir + order.length) % order.length]); }
      var sx=0, sy=0, sw=false;
      main.addEventListener('touchstart', function(e){
        if(e.touches.length !== 1) { sw=false; return; }
        sx=e.touches[0].clientX; sy=e.touches[0].clientY; sw=true;
      }, { passive: true });
      main.addEventListener('touchend', function(e){
        if(!sw) return; sw=false;
        var t=e.changedTouches[0], dx=t.clientX-sx, dy=t.clientY-sy;
        if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      }, { passive: true });
      var mx=0, md=false;
      main.addEventListener('mousedown', function(e){ md=true; mx=e.clientX; });
      window.addEventListener('mouseup', function(e){
        if(!md) return; md=false;
        var dx=e.clientX-mx; if(Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
      });
    }

    // Signaux de sélection renforcés (réglage « bundle_select_fx » de la section)
    var grid = root.querySelector('.rin-hero__bundles');
    var fx = !!(grid && grid.classList.contains('rin-hero__bundles--fx'));
    function setPrice(el, p){
      if(!el) return;
      if(fx && el.textContent !== p){
        el.textContent = p;
        el.classList.remove('rin-price-flash'); void el.offsetWidth; el.classList.add('rin-price-flash');
      } else { el.textContent = p; }
    }
    function selectVariant(card){
      cards.forEach(function(c){ c.classList.remove('is-active','is-popping'); c.setAttribute('aria-checked','false'); });
      card.classList.add('is-active'); card.setAttribute('aria-checked','true');
      // la pastille ✓ rejoue son animation à chaque tap, même sur la carte déjà sélectionnée
      if(fx){ void card.offsetWidth; card.classList.add('is-popping'); }
      var id = card.getAttribute('data-variant-id');
      var price = card.getAttribute('data-price');
      if(input) input.value = id;
      setPrice(atcPrice, price);
      if(atcBtn) atcBtn.disabled = card.getAttribute('data-available') !== 'true';
      if(stickyLine) stickyLine.textContent = card.getAttribute('data-title');
      setPrice(stickyPrice, price);
      if(stickyBtn) stickyBtn.disabled = card.getAttribute('data-available') !== 'true';
      if(variantMedia[id]) showMedia(variantMedia[id]);
      var url = new URL(window.location.href); url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url.toString());
    }
    var suppressClick = false;
    if(fx){
      var pressed = null, pressedRect = null;
      cards.forEach(function(c){
        c.addEventListener('pointerdown', function(){ pressed = c; pressedRect = c.getBoundingClientRect(); c.classList.add('is-pressed'); });
        ['pointerup','pointerleave','pointercancel'].forEach(function(ev){
          c.addEventListener(ev, function(){ setTimeout(function(){ c.classList.remove('is-pressed'); }, 100); });
        });
      });
      // La compression scale(.97) rétrécit la carte sous le doigt : près d'un bord, le relâchement tombe
      // hors du bouton et le click natif est perdu. Le tap est donc validé sur la géométrie d'avant compression.
      document.addEventListener('pointerup', function(e){
        var c = pressed, r = pressedRect; pressed = null; pressedRect = null;
        if(!c || !r) return;
        if(e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom){
          suppressClick = true; setTimeout(function(){ suppressClick = false; }, 400);
          selectVariant(c);
        }
      }, true);
      document.addEventListener('pointercancel', function(){ pressed = null; pressedRect = null; }, true);
    }
    // clic natif : clavier (Entrée / Espace) et pointeurs non gérés ci-dessus
    cards.forEach(function(c){ c.addEventListener('click', function(){ if(suppressClick) return; selectVariant(c); }); });

    document.addEventListener('rin:select-variant', function(e){
      var id = e.detail && e.detail.variantId;
      cards.forEach(function(c){ if(c.getAttribute('data-variant-id') === String(id)) selectVariant(c); });
      root.scrollIntoView({ behavior: 'smooth' });
    });

    root.querySelectorAll('.rin-brow').forEach(function(r){
      r.addEventListener('click', function(){
        root.querySelectorAll('.rin-brow').forEach(function(x){ x.classList.remove('is-active'); x.setAttribute('aria-pressed','false'); });
        r.classList.add('is-active'); r.setAttribute('aria-pressed','true');
      });
    });

    if(sticky){
      var form = root.querySelector('.rin-hero__form');
      var onScroll = function(){ sticky.classList.toggle('is-show', !!(form && form.getBoundingClientRect().bottom < 0)); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }

    // Sélection par défaut au chargement : ?variant= s'il existe, sinon la carte vedette (6 saponette)
    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    var defCard = urlVariant ? root.querySelector('.rin-bcard[data-variant-id="' + urlVariant + '"]') : null;
    if(!defCard) defCard = root.querySelector('.rin-bcard.rin-bcard--featured');
    if(defCard && !defCard.classList.contains('is-active')) selectVariant(defCard);
  });

  // Mini FAQ (colonne d'achat) — délégation : survit aux re-rendus de l'éditeur
  if(!window.__rinMiniFaqBound){
    window.__rinMiniFaqBound = true;
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.rin-mfaq__q');
      if(!btn) return;
      var item = btn.closest('.rin-mfaq__item');
      var wrap = btn.closest('.rin-mfaq') || document;
      var panel = item.querySelector('.rin-mfaq__a');
      var isOpen = item.classList.contains('is-open');
      wrap.querySelectorAll('.rin-mfaq__item.is-open').forEach(function(i){
        i.classList.remove('is-open');
        var q = i.querySelector('.rin-mfaq__q'); if(q) q.setAttribute('aria-expanded','false');
        var a = i.querySelector('.rin-mfaq__a'); if(a) a.style.maxHeight = null;
      });
      if(!isOpen && panel){
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded','true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  }
})();
